import { Suspense, type PropsWithChildren } from 'react'

import { BuscaClienteSkeleton } from '@/components/busca-cliente-skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'
import { ConfiguracoesParametrosSkeleton } from '@/pages/configuracoes/parametros/configuracoes-parametros.skeleton'
import { ConfiguracoesReservaSkeleton } from '@/pages/configuracoes/reserva/configuracoes-reserva.skeleton'

export const BuscarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <BuscaClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesReservaPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesReservaSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}

export const ConfiguracoesParametrosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesParametrosSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
